import $ from "jquery";

$( () => {
	$(document).on('click', '.team-member',function(event) {
        const description = $(event.target).closest('.team-member-text-description');
        if (description.length) {
            description.closest('.team-member-text').toggleClass('team-member-text--opened');
            return;
        }
		if ($(this).hasClass('team-member--opened')) {
			$(this).removeClass('team-member--opened');
            $(this).find('.team-member-text').removeClass('team-member-text--opened');
		} else {
			$(this).closest('.team').find('.team-member').removeClass('team-member--opened');
			$(this).addClass('team-member--opened');
		}
	});
});